const Accordion = (accordionId: string, independentPanels: boolean = false) => {
  const accordion = document.getElementById(accordionId);

  if (!accordion) {
    console.warn('accordion not found');
    return;
  }

  const panels = accordion.querySelectorAll('.accordion-panel');

  const initAccordion = () => {
    if (panels) {
      panels.forEach(panel => {
        const header = panel.querySelector('.accordion-header');

        header?.addEventListener('click', () => {
          if (independentPanels) {
            panel.classList.toggle('active');
          } else {
            // Remove 'active' class from all panels
            panels.forEach(p => p.classList.remove('active'));
            // Add 'active' class to the clicked panel
            panel.classList.add('active');
          }
        });
      });
    }
  };

  initAccordion();
};

export default Accordion;
